import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { LEGAL_DETAILS, hasCompleteBusinessDetails } from '../config/legal';
import { useI18n } from '../i18n/I18nContext';
import { getLegalCopy } from '../i18n/legalCopy';
import '../style/Homepage.css';

const LegalNotice = () => {
  const { language, t } = useI18n();
  const copy = getLegalCopy(language);
  const page = copy.legalNotice;
  const legalForm = String(LEGAL_DETAILS.legalForm || '').trim().toLowerCase() === 'sole trader'
    ? t('footer.soleTrader')
    : LEGAL_DETAILS.legalForm;
  const values = [
    LEGAL_DETAILS.brandName, LEGAL_DETAILS.operatorName, legalForm,
    LEGAL_DETAILS.businessId, LEGAL_DETAILS.registeredOffice, LEGAL_DETAILS.registerName,
    LEGAL_DETAILS.taxId, LEGAL_DETAILS.vatId, LEGAL_DETAILS.supportEmail, LEGAL_DETAILS.privacyEmail,
  ];

  return (
    <div>
      <Header />
      <main className="info-page legal-notice-page">
        <section className="info-hero">
          <p className="eyebrow">{page.eyebrow}</p><h1>{page.title}</h1><p>{page.intro}</p>
        </section>
        {!hasCompleteBusinessDetails && (
          <section className="legal-setup-notice" role="status">
            <strong>{page.setupTitle}</strong><p>{page.setupBody}</p>
          </section>
        )}
        <section className="legal-details-grid" aria-label={page.detailsLabel}>
          {page.labels.map((label, index) => (
            <article className={`legal-detail-card${values[index] ? '' : ' legal-detail-card--missing'}`} key={label}>
              <span>{label}</span><strong>{values[index] || copy.common.notSupplied}</strong>
            </article>
          ))}
        </section>
        <section className="terms-content">
          <article className="terms-section-card"><h2>{page.roleTitle}</h2><div>{page.role.map((item) => <p key={item}>{item}</p>)}</div></article>
          <article className="terms-section-card"><h2>{page.contactTitle}</h2><div>{page.contact.map((item) => <p key={item}>{item}</p>)}</div></article>
        </section>
        <section className="terms-contact-card">
          <div><p className="eyebrow">{page.relatedEyebrow}</p><h2>{page.relatedTitle}</h2></div>
          <p>{page.relatedLead} <Link to="/terms">{copy.common.terms}</Link>,{' '}
            <Link to="/privacy">{copy.common.privacy}</Link>, <Link to="/cookie-policy">{copy.common.cookies}</Link>{' '}
            {page.and} <Link to="/security">{copy.common.security}</Link>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LegalNotice;
